




import { Component, Vue } from "vue-property-decorator";
import Chart from "chart.js";
import ChartJsPluginZoom from "chartjs-plugin-zoom";
Chart.plugins.register(ChartJsPluginZoom); //to add the zoom plugin globally.

@Component({
  components: {}
})
export default class App extends Vue {}
